// src/Routes.jsx
import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AppLayoutWithTabs from "./components/layout/AppLayoutWithTabs";

import LandingPage from "./pages/landing";
import WealthDashboard from "./pages/wealth-dashboard";
import ReportsAnalytics from "./pages/reports-analytics";
import ExpenseTracking from "./pages/expense-tracking";
import IncomeManagement from "./pages/income-management";
import AssetPortfolio from "./pages/asset-portfolio";
import DebtLiabilities from "./pages/debt-liabilities";
import InvestmentsAllocations from "./pages/investments-allocations";
import Setup from "./pages/setup";
import SurplusRouting from "./pages/surplus-routing";
import DrawdownPriority from "./pages/drawdown-priority";
import SpecialEvents from "./pages/special-events";
import EmergencyFundPage from "./pages/emergency-fund";
import LearningCenter from "./pages/learning-center";
import LoginPage from "./pages/auth/LoginPage";
import NotFound from "./pages/NotFound";
import Upgrade from "./pages/upgrade";
import ThankYou from "./pages/thank-you";
import Billing from "./pages/billing";
import MonteCarloPage from "./pages/monte-carlo";
import SimplifiedVersion from "./pages/simplified-version";
import SimpleViewDisabled from "./pages/simple-view-disabled";
import { Navigate } from "react-router-dom";
import AboutUs from "./pages/about-us";
import PrivacyPolicy from "./pages/privacy-policy";
import TermsOfService from "./pages/terms-of-service";
import InitialSetupFlow from "./components/setup/InitialSetupFlow";

const Routes = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />

        {/* Initial Setup Route - Standalone, no layout */}
        <Route
          path="/initial-setup"
          element={
            <ProtectedRoute>
              <InitialSetupFlow />
            </ProtectedRoute>
          }
        />

        {/* Protected app shell with tabs */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayoutWithTabs />
            </ProtectedRoute>
          }
        >
          {/* Simple View Routes - Redirect to wealth-dashboard (mode selection removed) */}
          <Route path="/simple" element={<Navigate to="/wealth-dashboard" replace />} />
          <Route path="/simple-disabled" element={<Navigate to="/wealth-dashboard" replace />} />
          
          {/* Detailed View Routes */}
          <Route path="/wealth-dashboard" element={<WealthDashboard />} />
          <Route path="/learning-center" element={<LearningCenter />} />
          <Route path="/income-management" element={<IncomeManagement />} />
          <Route path="/expense-tracking" element={<ExpenseTracking />} />
          <Route path="/asset-portfolio" element={<AssetPortfolio />} />
          <Route path="/debt-liabilities" element={<DebtLiabilities />} />
          <Route path="/investments-allocations" element={<InvestmentsAllocations />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/surplus-routing" element={<SurplusRouting />} />
          <Route path="/drawdown-priority" element={<DrawdownPriority />} />
          <Route path="/special-events" element={<SpecialEvents />} />
          <Route path="/emergency-fund" element={<EmergencyFundPage />} />
          <Route path="/reports-analytics" element={<ReportsAnalytics />} />
          <Route path="/monte-carlo" element={<MonteCarloPage />} />
          <Route path="/upgrade" element={<Upgrade />} />
          <Route path="/thankyou" element={<ThankYou />} />
          <Route path="/billing" element={<Billing />} />
          
          {/* Legacy routes - redirect to wealth-dashboard (mode selection removed) */}
          <Route path="/simplified-version" element={<Navigate to="/wealth-dashboard" replace />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  </BrowserRouter>
);

export default Routes;
